var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-3531 -2063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape",
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#close_path0_fill",
    transform: "translate(3531 2063)",
    fill: "#FFFFFF",
    style: {
      mixBlendMode: "normal"
    }
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "close_path0_fill",
    fillRule: "evenodd",
    d: "M 16 1.7937L 14.2063 0L 8 6.2063L 1.7937 0L 0 1.7937L 6.2063 8L 0 14.2063L 1.7937 16L 8 9.7937L 14.2063 16L 16 14.2063L 9.7937 8L 16 1.7937Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.bfe3680a.svg";
export { ForwardRef as ReactComponent };